(function () {
  function closeAllHelpTooltips() {
    document.querySelectorAll('.variant-picker__help.is-active').forEach(function (help) {
      help.classList.remove('is-active');
      var btn = help.querySelector('.variant-picker__help-btn');
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initVariantPickerHelp() {
    document.querySelectorAll('.variant-picker__help-btn').forEach(function (btn) {
      if (btn.dataset.helpInit === 'true') {
        return;
      }

      btn.dataset.helpInit = 'true';

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var help = btn.closest('.variant-picker__help');
        if (!help) {
          return;
        }

        var isActive = help.classList.contains('is-active');
        closeAllHelpTooltips();

        if (!isActive) {
          help.classList.add('is-active');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function getProductVariants(picker) {
    var section = picker.closest('[data-section-id]') || picker.closest('.shopify-section');
    var productJsonEl = section && section.querySelector('[data-product-json]');

    if (!productJsonEl) {
      return [];
    }

    try {
      return JSON.parse(productJsonEl.textContent).variants || [];
    } catch (error) {
      return [];
    }
  }

  function getPickerSelectedOptions(picker) {
    var options = [];

    picker.querySelectorAll('.option-selector:not(.option-selector--custom)').forEach(function (selector) {
      if (selector.dataset.selectorType === 'dropdown') {
        var selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
        options.push(selected && selected.dataset.value !== '' ? selected.dataset.value : null);
      } else {
        var selectedInput = selector.querySelector('input:checked');
        options.push(selectedInput ? selectedInput.value : null);
      }
    });

    return options;
  }

  function findBestAvailableVariant(variants, selectedOptions) {
    var available = variants.filter(function (variant) {
      return variant.available;
    });

    if (!available.length) {
      return null;
    }

    var exactMatch = available.find(function (variant) {
      return selectedOptions.every(function (optionValue, index) {
        return optionValue === null || variant.options[index] === optionValue;
      });
    });

    if (exactMatch) {
      return exactMatch;
    }

    var index = selectedOptions.length - 1;
    while (index >= 0) {
      if (selectedOptions[index]) {
        var partialMatch = available.find(function (variant) {
          return variant.options[index] === selectedOptions[index];
        });

        if (partialMatch) {
          return partialMatch;
        }
      }

      index -= 1;
    }

    return available[0];
  }

  function applyVariantToPicker(picker, variant) {
    var selectors = picker.querySelectorAll('.option-selector:not(.option-selector--custom)');
    var lastChangedInput = null;

    variant.options.forEach(function (optionValue, index) {
      var selector = selectors[index];
      if (!selector) {
        return;
      }

      if (selector.dataset.selectorType === 'dropdown') {
        var dropdownOption = selector.querySelector(
          '.custom-select__option[data-value="' + CSS.escape(optionValue) + '"]:not(.is-unavailable)'
        ) || selector.querySelector('.custom-select__option:not(.is-unavailable)');

        if (dropdownOption && dropdownOption.getAttribute('aria-selected') !== 'true') {
          dropdownOption.closest('custom-select').selectOption(dropdownOption);
          lastChangedInput = dropdownOption;
        }
        return;
      }

      var input = selector.querySelector(
        'input[value="' + CSS.escape(optionValue) + '"]:not(.is-unavailable)'
      ) || selector.querySelector('input:not(.is-unavailable)');

      if (input && !input.checked) {
        var currentChecked = selector.querySelector('input:checked');
        if (currentChecked) {
          currentChecked.checked = false;
        }
        input.checked = true;
        lastChangedInput = input;
      }
    });

    if (lastChangedInput && !lastChangedInput.closest('custom-select')) {
      lastChangedInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function resolveUnavailableVariant(picker) {
    if (!picker.classList.contains('variant-picker--pdp')) {
      return;
    }

    if (picker.dataset.resolvingUnavailable === 'true') {
      return;
    }

    var variantDataEl = picker.querySelector('script[data-variant-data]');
    if (!variantDataEl) {
      return;
    }

    var currentVariant;

    try {
      currentVariant = JSON.parse(variantDataEl.textContent);
    } catch (error) {
      return;
    }

    if (!currentVariant || currentVariant.available) {
      return;
    }

    var variants = getProductVariants(picker);
    var selectedOptions = getPickerSelectedOptions(picker);
    var bestVariant = findBestAvailableVariant(variants, selectedOptions);

    if (!bestVariant) {
      return;
    }

    picker.dataset.resolvingUnavailable = 'true';
    applyVariantToPicker(picker, bestVariant);

    window.setTimeout(function () {
      delete picker.dataset.resolvingUnavailable;
    }, 500);
  }

  function initUnavailableGuard() {
    document.querySelectorAll('variant-picker.variant-picker--pdp').forEach(function (picker) {
      window.setTimeout(function () {
        resolveUnavailableVariant(picker);
      }, 100);
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.variant-picker__help')) {
      closeAllHelpTooltips();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllHelpTooltips();
    }
  });

  document.addEventListener('on:variant:change', function (event) {
    var picker = event.target && event.target.closest && event.target.closest('variant-picker.variant-picker--pdp');
    if (!picker) {
      return;
    }

    if (event.detail && event.detail.variant && event.detail.variant.available) {
      return;
    }

    window.setTimeout(function () {
      resolveUnavailableVariant(picker);
    }, 50);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initVariantPickerHelp();
    initUnavailableGuard();
  });

  document.addEventListener('shopify:section:load', function () {
    initVariantPickerHelp();
    initUnavailableGuard();
  });
})();
